var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "21px",
    fill: "#707070",
    height: "16px",
    viewBox: "0 0 544.49 544.489",
    style: {
      enableBackground: "new 0 0 544.49 544.489"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 243.92,
    cy: 23.18,
    r: 1.606
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.616,
    cy: 23.18,
    r: 1.606
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 253.301,
    cy: 23.18,
    r: 1.606
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.987,
    cy: 23.18,
    r: 1.606
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262.682,
    cy: 23.18,
    r: 1.606
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.377,
    cy: 23.18,
    r: 1.606
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.063,
    cy: 23.18,
    r: 1.606
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.749,
    cy: 23.18,
    r: 1.606
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.434,
    cy: 23.18,
    r: 1.606
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.149,
    cy: 23.18,
    r: 1.606
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.834,
    cy: 23.18,
    r: 1.606
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.52,
    cy: 23.18,
    r: 1.606
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.206,
    cy: 23.18,
    r: 1.606
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.901,
    cy: 23.18,
    r: 1.606
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.923,0H151.576c-19.508,0-35.314,15.807-35.314,35.314v473.86c0,19.507,15.807,35.314,35.314,35.314h241.338 c19.508,0,35.314-15.808,35.314-35.314V35.314C428.238,15.807,412.431,0,392.923,0z M368.233,20.971 c2.151,0,3.901,1.75,3.901,3.901c0,2.161-1.759,3.901-3.901,3.901c-2.161,0-3.901-1.75-3.901-3.901 C364.322,22.721,366.072,20.971,368.233,20.971z M230.476,17.604h87.219c3.089,0,5.575,2.496,5.575,5.565 c0,3.079-2.486,5.565-5.575,5.565h-87.219c-3.089,0-5.575-2.496-5.575-5.565C224.911,20.101,227.387,17.604,230.476,17.604z  M194.894,521.262h-8.587c-0.574,0-1.033-0.469-1.033-1.043c0-0.563,0.459-1.042,1.033-1.042h8.587 c0.583,0,1.042,0.479,1.042,1.042C195.926,520.793,195.467,521.262,194.894,521.262z M194.894,517.073h-8.587 c-0.574,0-1.033-0.459-1.033-1.033c0-0.573,0.459-1.042,1.033-1.042h8.587c0.583,0,1.042,0.469,1.042,1.042 C195.926,516.614,195.467,517.073,194.894,517.073z M202.123,519.798c0,1.234-0.995,2.238-2.228,2.238 c-1.234,0-2.238-1.004-2.238-2.238v-7.372h-14.124v7.372c0,1.234-0.994,2.238-2.228,2.238c-1.233,0-2.237-1.004-2.237-2.238 v-9.601c0-1.233,1.004-2.237,2.237-2.237h18.59c1.233,0,2.228,1.004,2.228,2.237V519.798L202.123,519.798z M300.206,519.11 c0,4.876-3.959,8.826-8.836,8.826h-38.623c-4.887,0-8.836-3.95-8.836-8.826v-7.727c0-4.877,3.949-8.826,8.836-8.826h38.623 c4.877,0,8.836,3.949,8.836,8.826V519.11z M357.858,522.457h-7.01c-1.233,0-2.228-1.004-2.228-2.238 c0-1.233,0.994-2.228,2.228-2.228h7.01c1.511,0,2.734-1.177,2.734-2.62c0-1.444-1.224-2.61-2.734-2.61h-5.91 c-0.22,0.306-0.497,0.459-0.994,0.497c-0.124,0.066-0.335-0.029-0.487-0.096l-3.644-1.54c-0.44-0.191-0.736-0.621-0.736-1.1 c0-0.478,0.287-0.918,0.727-1.1l3.644-1.539c0.439-0.191,0.966-0.086,1.31,0.258c0.048,0.048,0.096,0.096,0.134,0.153h5.958 c3.969,0,7.19,3.184,7.19,7.086C365.048,519.282,361.827,522.457,357.858,522.457z M404.685,491.513H136.859V54.449h267.826 V491.513z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.348a0d43d2cf01f354d4ca7011693da0.svg";
export { ForwardRef as ReactComponent };